import { render, staticRenderFns } from "./Interviews.vue?vue&type=template&id=2a9bf124&scoped=true"
import script from "./Interviews.vue?vue&type=script&lang=js"
export * from "./Interviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9bf124",
  null
  
)

export default component.exports